import { useFlysiteUrls } from 'hooks/useFlysiteUrls/useFlysiteUrls';
import { useTranslations } from 'utils/translations/useTranslations';

export const PrivacyPolicyLink = () => {
  const { privacyUrl } = useFlysiteUrls();
  const i18n = useTranslations();

  return (
    <a
      data-testid="privacy-policy-link"
      className="Link"
      href={privacyUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {i18n.t('checkout.termsAndConditions.privacy_policy')}
    </a>
  );
};
